const getTestFromBiomarker = (biomarker) => {
  const mapBiomarkerToTest = new Map([
    ['cortisol', { name: 'cortisol', id: 53 }],
    ['testosterone', { name: 'fatburninghormones', id: 221 }],
    ['vitamind', { name: 'focus', id: 68 }],
    ['fatigue', { name: 'focus', id: 68 }],
    ['crp', { name: 'sugar&inflammation', id: 65 }],
    ['hba1c', { name: 'sugar&inflammation', id: 65 }],
    ['ferritin', { name: 'energyvitamins', id: 209 }],
    ['iron', { name: 'energyvitamins', id: 209 }],
    ['vitaminb12', { name: 'energyvitamins', id: 209 }],
    ['tsh', { name: 'thyroidhormones', id: 76 }],
    ['hypothyroidism', { name: 'thyroidhormones', id: 15 }],
    ['t4', { name: 'thyroidhormones', id: 76 }],
    ['t3', { name: 'thyroidhormones', id: 76 }],
    ['melatonin', { name: 'melatonin', id: 94 }],
    ['triglycerides', { name: 'cholesterol&lipids', id: 1 }],
    ['ldl', { name: 'cholesterol&lipids', id: 1 }],
    ['hdl', { name: 'cholesterol&lipids', id: 1 }],
    ['totalcholesterol', { name: 'cholesterol&lipids', id: 1 }],
    ['estradiol', { name: 'femalehormones', id: 117 }],
    ['progesterone', { name: 'femalehormones', id: 117 }],
    ['femalehormonestest', { name: 'femalehormones', id: 117 }]
  ])
  if (mapBiomarkerToTest.has(biomarker)) {
    return mapBiomarkerToTest.get(biomarker)
  } else {
    throw new Error(`Biomarker ${biomarker} does not exist in the mapping. Please add it.`)
  }
}

const getAreaFromTest = (test) => {
  const mapTestToArea = new Map([
    ['thyroidhormones', 'diet'],
    ['sugar&inflammation', 'diet'],
    ['cholesterol&lipids', 'diet'],
    ['fatburninghormones', 'diet'],
    ['focus', 'energy'],
    ['cortisol', 'stress'],
    ['energyvitamins', 'energy'],
    ['femalehormones', 'sex-drive'],
    ['melatonin', 'sleep']
  ])
  if (mapTestToArea.has(test)) {
    return mapTestToArea.get(test)
  } else {
    throw new Error(`Test ${test} does not exist in the mapping. Please add it.`)
  }
}

export {
  getTestFromBiomarker,
  getAreaFromTest
}
